/* eslint-disable no-unused-vars */
import { GraphQLFormattedError } from "graphql";
import { actionTypes } from "./toastMessage.actions";
import React from "react";

export interface IToastMessageState {
  error: ReadonlyArray<GraphQLFormattedError> | null;
  isLoading: boolean;
  message: string;
  severity: "error" | "warning" | "info" | "success";
  customMessage?: JSX.Element | null;
  customIcon?: string;
  alertType?: string;
};

const initialState: IToastMessageState = {
  error: null,
  isLoading: false,
  message: "",
  severity: "error",
  customMessage: null,
  customIcon: "",
  alertType: "",
};

export const toastReducer = (
  state: IToastMessageState = initialState,
  action: { type: string, payload: boolean | ReadonlyArray<GraphQLFormattedError> | any },
) => {
  switch (action.type) {
  case actionTypes.SET_GLOBAL_LOADING:
    return {
      ...state,
      isLoading: action.payload,
    };
  case actionTypes.REQUEST_FAILURE:
    return {
      ...state,
      isLoading: false,
      severity: "error",
      error: action.payload,
    };
  case actionTypes.SET_GLOBAL_ALERT:
    return {
      ...state,
      error: null,
      severity: action.payload.severity || "",
      message: action.payload.message,
      customIcon: action.payload.customIcon || "",
      alertType: action.payload.alertType || "",
      customMessage: action.payload.customMessage || "",
    };
  case actionTypes.RESET_GLOBAL_ALERT:
    return initialState;
  default:
    return state;
  }
};
